/**
 * og:image — obrázek pro sdílení na sociálních sítích.
 *
 * Chování přebrané ze starého PHP webu: obrázek entity (článek / realizace /
 * odpověď), a když ho entita nemá, výchozí `design_share_image` z nastavení.
 * Když není ani ten, tag se nevykreslí vůbec (useSeoMeta vynechá `undefined`) —
 * prázdný `og:image` je horší než žádný, crawler by na něj sáhl a dostal 404.
 */

/** Crawlery relativní cestu nevezmou — doplní origin z aktuálního requestu. */
function absoluteUrl(url?: string | null): string {
  if (!url) return ''
  if (/^https?:\/\//i.test(url)) return url
  // useRequestURL() funguje na serveru (z příchozího requestu) i na klientu.
  const origin = useRequestURL().origin
  return url.startsWith('/') ? `${origin}${url}` : `${origin}/${url}`
}

/** Výchozí sdílecí obrázek webu (`design_share_image`). */
export function useDefaultOgImage() {
  const { data: design } = useDesignSettings()
  return computed(() => absoluteUrl(design.value?.shareImage) || undefined)
}

/**
 * Absolutní URL pro og:image: obrázek entity, jinak výchozí sdílecí obrázek,
 * jinak `undefined`. `source` předávej jako getter, ať zůstane reaktivní, než
 * doběhne dotaz na entitu.
 */
export function useOgImage(source?: MaybeRefOrGetter<string | null | undefined>) {
  const fallback = useDefaultOgImage()
  return computed(() => absoluteUrl(toValue(source)) || fallback.value)
}
